import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const cmsContactBlockSettingsEntity: Entity = {
  model: model,
  repository: repository,
}

export default cmsContactBlockSettingsEntity
